import React from 'react';

import { TextInput as OldTextInput } from '@components/Forms/TextInput';
import { makeMuiStyles } from '@styles';

const useStyles = makeMuiStyles((theme, common) => ({
  label: {
    ...common.bigText,
    ...common.fontWeight500,
    ...common.textGray800,
    textAlign: 'left',
    minWidth: 70,
  },
}));

export const TextInput: typeof OldTextInput = (props) => {
  const { formClasses, ...rest } = props;

  const classes = useStyles();

  return (
    <OldTextInput
      formClasses={{
        label: classes.label,
        ...formClasses,
      }}
      bordered={false}
      {...rest}
    />
  );
};
